import styled from "styled-components";

export const ControllerMemberJoinWrapper = styled.div<{ isWide: boolean }>`
  width: ${(p) => (p.isWide ? "440px" : "100%")};
  height: 366px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 40px 15px 0;
  box-sizing: border-box;
  border-radius: 12px;
  background: #fff;
  position: absolute;
  z-index: 100;

  > .title {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 20px;
    line-height: 100%;
    color: #121212;
    margin-bottom: 12px;
  }
`;

export const ControllerMemberJoinSearchWrapper = styled.div`
  width: 100%;

  > .input-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;

export const ControllerMemberJoinText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
  color: var(--color-Blue-Purple-Heart-58, #6436e7);
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: var(--shadow-offset-0, 0);
`;
